module.exports = __webpack_public_path__ + "static/media/ship_brown_flip.6da0a588.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_brown_flip.png
// module id = 207
// module chunks = 0